import BaseNotification from './BaseNotification';

export default BaseNotification;
